<div class="card" style="width: 100%;">
    <div class="card-header d-flex justify-content-between align-items-center" style="width: 100%;">
      <h4 class="mb-0">{{ data?.title }}</h4>
    </div>
  
    <div class="card-body position-relative p-0">
      <!-- Loading Spinner -->
      <div *ngIf="isLoading" class="text-center p-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2">Loading data...</p>
      </div>
  
      <!-- Error Message -->
      <div *ngIf="error" class="alert alert-danger m-3" role="alert">
        {{ error }}
      </div>
  
      <!-- Filter Section removed: using Global Filters component to drive backend payloads -->
  
      <!-- Table -->
      <div *ngIf="!isLoading && !error" class="table-responsive">
        <table class="table table-hover mb-0" style="border: 1px solid #b71c1c;">
          <thead style="background-color: #b71c1c; color: #fff;">
            <tr>
              <!-- S.No Column Only -->
              <th *ngIf="showSerialNumber" style="min-width: 80px; background-color: #b71c1c; color: #fff;">
                <span>Sr.No</span>
              </th>
  
              <!-- Data Columns -->
              <th
                *ngFor="let column of columns"
                [class.text-end]="column.align === 'right'"
                [class.text-center]="column.align === 'center'"
                [style.width]="column.width"
                [style.white-space]="'pre-line'"
                style="background-color: #b71c1c; color: #fff;"
              >
                {{ column.label }}
              </th>
            </tr>
          </thead>
  
          <tbody>
            <tr *ngFor="let item of tableData; let i = index" [ngClass]="{'table-row-alt': i % 2 === 1}">
              <!-- S.No Cell Only -->
              <td *ngIf="showSerialNumber" class="align-middle">
                <span class="text-muted fw-medium">{{ i + 1 }}.</span>
              </td>
  
              <!-- Data Cells -->
              <td
                *ngFor="let column of columns"
                [class.text-end]="column.align === 'right'"
                [class.text-center]="column.align === 'center'"
                [class.truncate]="!isNumeric(column.key)"
                [attr.title]="item[column.key]"
              >
                <ng-container *ngIf="isNumeric(column.key) && item[column.key] !== null && item[column.key] !== undefined; else textCell">
                  {{ item[column.key] }}
                </ng-container>
                <ng-template #textCell>
                  {{ item[column.key] }}
                </ng-template>
              </td>
            </tr>
  
            <!-- Empty State -->
            <tr *ngIf="tableData.length === 0">
              <td [attr.colspan]="getColSpan()" class="text-center py-4 text-muted">
                No data available
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  <style>
.table-row-alt {
  background-color: #f5f5f5;
}
</style>